import {
  HEADER_PROFILE_MENU_CLICK,
  HEADER_SHOPPING_CART_BTN_CLICK,
  HEADER_SIGNOUT_BTN_CLICK,
  HEADER_LOGO_CLICK,
} from './header.tracking.constants';
import { track } from './tracking';

export const trackHeaderProfileMenuClick = (menu_item_label) => {
  track(HEADER_PROFILE_MENU_CLICK, { menu_item_label });
};

export const trackHeaderShoppingCartButtonClick = () => {
  track(HEADER_SHOPPING_CART_BTN_CLICK);
};

export const trackHeaderSignoutButtonClick = () => {
  track(HEADER_SIGNOUT_BTN_CLICK);
};

export const trackHeaderLogoClick = () => {
  track(HEADER_LOGO_CLICK);
};
